import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class ItemAddonKind extends Cloneable {
    static NONE = new ItemAddonKind(0, "NONE");

    static _values = [
        new ItemAddonKind(1, "FC_SLOT_1"),
        new ItemAddonKind(2, "FC_SLOT_2"),
        new ItemAddonKind(3, "FC_SLOT_3"),
        new ItemAddonKind(4, "FC_SLOT_4"),
    ];

    static getValues() {
        return ItemAddonKind._values;
    }

    static getValue(id) {
        let value = ItemAddonKind._values.find(v => v.id === id) || null;
        console.assert(value, "unknown addon: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemAddonKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof ItemAddonKind) {
            return ItemAddonKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemAddonKind.NONE.equal(value);
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof ItemAddonKind) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemAddonKind());
        } else if (target instanceof ItemAddonKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemAddonKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});